/* eslint-disable react/jsx-boolean-value */
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Checkbox, FormControl, FormControlLabel, FormHelperText } from '@mui/material';
import useReactHookFormStyles from '../../../../custom-components/form-components/ReactHookForm.styles';

const BooleanCheckbox = ({ name, props: { label, defaultValue, optionMap, variant, required, map, LabelSx, ...rest } }) => {
    const classes = useReactHookFormStyles();

    const {
        control,
        formState: { errors },
    } = useFormContext();

    const mappedValue = (value) => map.true === value;

    return (
        <FormControl className={classes.formController}>
            <Controller
                name={name}
                control={control}
                defaultValue={defaultValue}
                render={({ field: { onChange, value } }) => {
                    return (
                        <FormControlLabel
                            sx={LabelSx}
                            label={label}
                            control={
                                <Checkbox
                                    // Coerced so the box is controlled from the first render even
                                    // without a defaultValue; otherwise MUI keeps its own state and
                                    // a later setValue updates the form but not the tick
                                    checked={map ? mappedValue(value) : !!value}
                                    onChange={(_e, val) => (map ? onChange(map[val]) : onChange(val))}
                                    {...rest}
                                    // wrap
                                />
                            }
                            // wrap
                        />
                    );
                }}
            />
            {!!errors[name] && <FormHelperText>{errors[name]?.message}</FormHelperText>}
        </FormControl>
    );
};

export default React.memo(BooleanCheckbox);
